import { getCustomNotesTypeList } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// State interface definition
interface CustomNotesTypeListState {
  CustomNotesTypeList: any[];
  isLoading: boolean;
  error: string | null;
}

// Initial state setup
const initialState: CustomNotesTypeListState = {
  CustomNotesTypeList: [],
  isLoading: false,
  error: null,
};

// Async action to fetch error mapping note type list
export const FetchCustomNotesTypeList = createAsyncThunk(
  "CustomNotesTypeList/fetchCustomNotesTypeList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getCustomNotesTypeList(params);
      const state: any = getState();
      const previousCustomNotesTypeList = state.CustomNotesTypeList?.CustomNotesTypeList || []; 
      if ([1, undefined].includes(res?.result?.page)) {

        dispatch(getCustomNotesType(res?.result?.data || []));
      } else {

        dispatch(getCustomNotesType([
          ...previousCustomNotesTypeList, 
          ...(res?.result?.data || []), 
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching custom notes type list');
    }
  }
);

// Slice to manage CustomNotesTypeList state
const CustomNotesTypeListSlice = createSlice({
  name: 'CustomNotesTypeList',
  initialState,
  reducers: {
    getCustomNotesType(state, action: PayloadAction<any[]>) {
      state.CustomNotesTypeList = action.payload;
    },
  }
});

export default CustomNotesTypeListSlice.reducer;
export const { getCustomNotesType } = CustomNotesTypeListSlice.actions;
